import { render, staticRenderFns } from "./InvestigationItem.vue?vue&type=template&id=e8c026b0&"
import script from "./InvestigationItem.vue?vue&type=script&lang=js&"
export * from "./InvestigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports